import { BrowserModule } from "@angular/platform-browser";
import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { Routes, RouterModule, Router } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  AppComponent,
  RelativeDatePipe,
  FirstLetterPipe,
  SafePipe,
  LimitPipe,
  NewlinePipe,
} from "./app.component";
import { LaterComponent } from "./components/later/later.component";
import { LessonHeaderComponent } from "./pages/lesson-header/lesson-header.component";
import { LessonsInformationComponent } from "./pages/lessons-information/lessons-information.component";
import { ContactUsComponent } from "./pages/contact-us/contact-us.component";
import { HomeComponent } from "./pages/home/home.component";
import { MyLessonsComponent } from "./pages/my-lessons/my-lessons.component";
import { environment } from "../environments/environment";
import { FinishedComponent } from "./pages/finished/finished.component";
import { MessagesComponent } from "./pages/messages/messages.component";
import { TourComponent } from "./pages/tour/tour.component";
import { ContactsPage } from "./pages/contacts-page/contacts-page.component";
import { BypassComponent } from "./components/bypass/bypass.component";
import { EntityComponent } from "./components/entity/entity.component";

import { ProfileComponent } from "./components/profile/profile.component";
import { BradshawComponent } from "./components/bradshaw/bradshaw.component";
import { HeaderImageComponent } from "./components/header-image/header-image.component";
import { AppDownloadSectionComponent } from "./components/app-download-section/app-download-section.component";
import { FooterSectionComponent } from "./components/footer-section/footer-section.component";
import { LoginSignUpComponent } from "./components/login-sign-up/login-sign-up.component";
import { NavigationBarComponent } from "./components/navigation-bar/navigation-bar.component";
import { LessonsFlatComponent } from "./components/lessons-flat/lessons-flat.component";
import { BetaComponent } from "./components/beta/beta.component";
import { LessonBlocksComponent } from "./components/lesson-blocks/lesson-blocks.component";
import { LessonHeaderBarComponent } from "./components/lesson-header-bar/lesson-header-bar.component";
import { AdvertiseComponent } from "./components/advertise/advertise.component";
import { VolunteerComponent } from "./components/volunteer/volunteer.component";
import { SingleMessageComponent } from "./components/single-message/single-message.component";
import { InstructionComponent } from "./components/instruction/instruction.component";
import { UserProfileComponent } from "./components/user-profile/user-profile.component";
import { LessonTemplateComponent } from "./templates/lesson-template/lesson-template.component";
import { QuestionTemplateComponent } from "./templates/question-template/question-template.component";

import { UserManager } from "./Services/UserManager/user-manager";
import { AngularFireModule } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { AngularFirestoreModule } from "@angular/fire/firestore";
import { AngularFireFunctionsModule } from "@angular/fire/functions";
import { LessonManagerService } from "./Services/LessonManager/lesson-manager.service";
import { GlobalVariablesService } from "./Services/globalVariables/global-variables.service";
import { ScrollService } from "./Services/ScrollManager/scroll.service";
import { NgxPageScrollModule } from "ngx-page-scroll";
import { NgxPageScrollCoreModule } from "ngx-page-scroll-core";

import { ClipboardModule } from "@angular/cdk/clipboard";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatNativeDateModule } from "@angular/material/core";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";

import { ChurchApplicationsComponent } from "./components/church-applications/church-applications.component";
import { NewChurchApplicationComponent } from "./my-school/new-church-application/new-church-application.component";
import { MySchoolAdminComponent } from "./my-school/my-school-admin/my-school-admin.component";
import { MySchoolInstructorComponent } from "./my-school/my-school-instructor/my-school-instructor.component";
import { MySchoolComponent } from "./my-school/my-school/my-school.component";
import { MySchoolContactsComponent } from "./my-school/my-school-contacts/my-school-contacts.component";
import { MySchoolAddInstructorComponent } from "./my-school/my-school-add-instructor/my-school-add-instructor.component";
import { InstructorRegistrationComponent } from "./components/instructor-registration/instructor-registration.component";
import { MessageSheetComponent } from "./components/message-sheet/message-sheet.component";
import { AutoUnlockLessonsComponent } from "./components/auto-unlock-lessons/auto-unlock-lessons.component";
import { LinkComponent } from "./pages/link/link.component";
import { HttpClientModule } from "@angular/common/http";
import { MatStepperModule } from "@angular/material/stepper";
import { MatButtonToggleModule } from "@angular/material/button-toggle";

import { VgCoreModule } from "@videogular/ngx-videogular/core";
import { VgControlsModule } from "@videogular/ngx-videogular/controls";
import { VgOverlayPlayModule } from "@videogular/ngx-videogular/overlay-play";
import { VgBufferingModule } from "@videogular/ngx-videogular/buffering";
import { VgStreamingModule } from "@videogular/ngx-videogular/streaming";
import { ContactSheetComponent } from "./components/contact-sheet/contact-sheet.component";
import { ProfileSheetComponent } from "./components/profile-sheet/profile-sheet.component";
import { AdminViewComponent } from "./admin/admin-view/admin-view.component";
import { LookupComponent } from "./components/lookup/lookup.component";
import { ApplicationViewComponent } from "./admin/application-view/application-view.component";
import { InvitationsComponent } from "./invitations/invitations.component";
import { OrgActivityComponent } from "./admin/org-activity/org-activity.component";
import { AdminContactsComponent } from "./admin/admin-contacts/admin-contacts.component";
import { LessonCardComponent } from "./components/lesson-card/lesson-card.component";
import { TryLessonComponent } from "./components/try-lesson/try-lesson.component";
import { LessonAniComponent } from "./components/lesson-ani/lesson-ani.component";
import { VisibleDirective } from "./visible.directive";
import { LayoutComponent } from "./components/layout/layout.component";
import { TryAgainComponent } from "./components/try-again/try-again.component";
import { SecondComponent } from "./components/second/second.component";
import { SecondCardComponent } from "./components/second-card/second-card.component";
import { GradientButtonComponent } from "./components/gradient-button/gradient-button.component";
import { TextButtonComponent } from "./components/text-button/text-button.component";
import { Ani2Component } from "./components/ani2/ani2.component";
import { AvatarComponent } from "./components/avatar/avatar.component";
import { FAQComponent } from "./components/faq/faq.component";
import { VisibleObserverDirective } from "./components/visible-observer.directive";
import { RevelationTodayEmailComponent } from "./components/revelation-today-email/revelation-today-email.component";
import { RevelationTodayUidComponent } from "./components/revelation-today-uid/revelation-today-uid.component";
import { FinishMagicLinkComponent } from "./components/finish-magic-link/finish-magic-link.component";
import { AdminLanguagesComponent } from "./admin/admin-languages/admin-languages.component";
import { NewLanguageDialogComponent } from "./admin/admin-new-language-dialog/admin-new-language-dialog.component";
import { EmailPreferenceCheckerComponent } from "./components/email-preference-checker/email-preference-checker.component";
import { LanguageSwitchComponent } from "./components/language-switch/language-switch.component";
import { LanguageSwitchService } from "./Services/LanguageSwitch/language-switch.service";
import { SiteConfigComponent } from "./pages/site-config/site-config.component";
import { ConfigEditorComponent } from "./components/config-editor/config-editor.component";
import { PageHeaderComponent } from "./components/page-header/page-header.component";
import { AdminLanguagesBottomSheetComponent } from "./admin-languages-bottom-sheet/admin-languages-bottom-sheet.component";
import { LessonEditorComponent } from "./components/lesson-editor/lesson-editor.component";
import { LessonPageComponent } from "./components/lesson-page/lesson-page.component";
import { QuestionComponent } from "./components/question/question.component";
import { QuestionTitleComponent } from "./components/question-title/question-title.component";
import { QuestionVersesComponent } from "./components/question-verses/question-verses.component";
import { StudentQuestionButtonComponent } from "./student-question-button/student-question-button.component";
import { QuestionInstructionsComponent } from './components/question-instructions/question-instructions.component';
import { QuestionVersePromptsComponent } from './components/question-verse-prompts/question-verse-prompts.component';
import { QuestionEditorComponent } from './components/question-editor/question-editor.component';

const router: Routes = [
  { path: "", redirectTo: "home", pathMatch: "full" },
  { path: "lesson/:id", component: BypassComponent },
  {
    path: "rte/lesson/:id/:email/:uid",
    component: RevelationTodayEmailComponent,
  },
  { path: "rtu/lesson/:id/:uid", component: RevelationTodayUidComponent },
  { path: "eulink", component: FinishMagicLinkComponent },
  { path: "my-school", component: MySchoolComponent },

  { path: "applications/:id", component: ChurchApplicationsComponent },
  {
    path: "register/:orgId/:invitationId",
    component: InstructorRegistrationComponent,
  },
  { path: "register/:id", component: EntityComponent },
  { path: "apply", component: NewChurchApplicationComponent },
  { path: "lessons-information", component: LessonsInformationComponent },
  { path: "lesson-template", component: LessonTemplateComponent },
  { path: "lesson-page/:id", component: LessonPageComponent },
  { path: "lesson-header", component: LessonHeaderComponent },
  { path: "home", component: HomeComponent },
  { path: "config-editor", component: SiteConfigComponent },
  { path: "config-editor/:id", component: SiteConfigComponent },
  { path: "lesson-editor", component: LessonEditorComponent },
  {
    path: "lesson-editor/:id",
    children: [
      { path: "", component: LessonEditorComponent },
      { path: "lesson/:lessonId", component: LessonEditorComponent },
    ],
  },
  {
    path: "home/:code",
    component: LanguageSwitchComponent,
  },
  { path: "contact-us", component: ContactUsComponent },
  { path: "my-lessons", component: MyLessonsComponent },
  { path: "finished", component: FinishedComponent },
  { path: "messages", component: MessagesComponent },
  { path: "tour", component: TourComponent },
  { path: "tour/:id", component: TourComponent },
  { path: "profile", component: UserProfileComponent },
  { path: "linking", component: LinkComponent },
  { path: "admin", component: AdminViewComponent },
  { path: "admin/:tab", component: AdminViewComponent },
  { path: "**", redirectTo: "home" },
];

@NgModule({
  declarations: [
    AppComponent,
    LaterComponent,
    RelativeDatePipe,
    BradshawComponent,
    HeaderImageComponent,
    LessonTemplateComponent,
    QuestionTemplateComponent,
    AppDownloadSectionComponent,
    FooterSectionComponent,
    MySchoolAdminComponent,
    LoginSignUpComponent,
    HomeComponent,
    NavigationBarComponent,
    LessonsFlatComponent,
    ContactUsComponent,
    LessonsInformationComponent,
    LessonHeaderComponent,
    BetaComponent,
    MyLessonsComponent,
    FinishedComponent,
    LessonBlocksComponent,
    LessonBlocksComponent,
    LessonHeaderBarComponent,
    AdvertiseComponent,
    VolunteerComponent,
    MessagesComponent,
    UserProfileComponent,
    SingleMessageComponent,
    TourComponent,
    InstructionComponent,
    ContactsPage,
    ProfileComponent,
    BypassComponent,
    EntityComponent,
    FirstLetterPipe,
    RelativeDatePipe,
    NewlinePipe,
    LimitPipe,
    SafePipe,
    ChurchApplicationsComponent,
    NewChurchApplicationComponent,
    MySchoolInstructorComponent,
    MySchoolComponent,
    MySchoolContactsComponent,
    MySchoolAddInstructorComponent,
    InstructorRegistrationComponent,
    MessageSheetComponent,
    AutoUnlockLessonsComponent,
    LinkComponent,
    ContactSheetComponent,
    ProfileSheetComponent,
    AdminViewComponent,
    LookupComponent,
    ApplicationViewComponent,
    InvitationsComponent,
    OrgActivityComponent,
    AdminContactsComponent,
    LessonCardComponent,
    TryLessonComponent,
    LessonAniComponent,
    VisibleDirective,
    LayoutComponent,
    TryAgainComponent,
    SecondComponent,
    SecondCardComponent,
    GradientButtonComponent,
    TextButtonComponent,
    Ani2Component,
    AvatarComponent,
    FAQComponent,
    VisibleObserverDirective,
    RevelationTodayEmailComponent,
    RevelationTodayUidComponent,
    FinishMagicLinkComponent,
    AdminLanguagesComponent,
    NewLanguageDialogComponent,
    EmailPreferenceCheckerComponent,
    LanguageSwitchComponent,
    SiteConfigComponent,
    ConfigEditorComponent,
    PageHeaderComponent,
    AdminLanguagesBottomSheetComponent,
    LessonEditorComponent,
    LessonPageComponent,
    QuestionComponent,
    QuestionTitleComponent,
    QuestionVersesComponent,
    StudentQuestionButtonComponent,
    QuestionInstructionsComponent,
    QuestionVersePromptsComponent,
    QuestionEditorComponent,
  ],
  imports: [
    AngularFireFunctionsModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    BrowserAnimationsModule,
    BrowserModule,
    ClipboardModule,
    DragDropModule,
    FormsModule,
    HttpClientModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
    NgxPageScrollCoreModule,
    ReactiveFormsModule,
    RouterModule.forRoot(router),
    VgBufferingModule,
    VgControlsModule,
    VgCoreModule,
    VgOverlayPlayModule,
    VgStreamingModule,
    MatButtonToggleModule,
  ],
  providers: [
    UserManager,
    AngularFireAuthModule,
    LessonManagerService,
    GlobalVariablesService,
    NgxPageScrollModule,
    ScrollService,
    LanguageSwitchService,
  ],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class AppModule {}
